import React from 'react';
import {NavLink, Redirect, Route, Switch} from 'react-router-dom';

export const findDefaultRoute = (routes) => {
  const routeEntries = Object.entries(routes);
  let foundRouteEntry = routeEntries.find(([, {isDefault}]) => isDefault);
  if (!foundRouteEntry) {
    return routeEntries[0][0];
  }
  return foundRouteEntry[0];
};


export const renderNavigation = ({routes, styles, sessionInfo}) => {
  return Object.entries(routes).map(([key, route]) => {
    if(route.displayFor && !route.displayFor.includes(sessionInfo.role)) return '';
    return (
      <NavLink
        className={(isActive) => {
          const className = [styles.navigationItem];
          if (isActive) {
            className.push(styles.activeNavigationItem);
          }
          return className.join(' ');
        }}
        key={key}
        to={key}
      >
        <span className={styles.navigationItemText}>{route.label}</span>
      </NavLink>
    );
  });
};

export const renderRouting = ({routes, wrapContent = ({content}) => content}) => {
  return (
    <Switch>
      {Object.entries(routes).map(([key, route]) => (
        <Route key={key} path={key}>
          {wrapContent({
            route,
            content: route.renderContent(),
          })}
        </Route>
      ))}
      <Redirect to={findDefaultRoute(routes)} />
    </Switch>
  );
};
